import Modal from 'react-bootstrap/Modal';
import party from 'party-js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import BecomeCreatorAvatar from '../images/Becomecreatorpopupavataricon.png';
import { useEffect } from 'react';

const PConfettiModal = ({ show, setShow }) => {
    useEffect(() => {
        setTimeout(() => {
            party.confetti(document.getElementById('congrats-confetti'), {
                count: party.variation.range(70, 200),
                size: party.variation.range(0.6, 1.4)
            });
        }, 550);
    }, []);

    const handleOkay = () => {
        setShow(false);
        window.location.reload();
    };

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            aria-labelledby="contained-modal-title-vcenter"
            siz="lg"
            centered
            id="congrats-confetti"
            className="congrats-confetti"
        >
            <Modal.Body>
                <div className="text-center" style={{ fontSize: '16px' }}>
                    <LazyLoadImage src={BecomeCreatorAvatar} width="40%" style={{ marginTop: '-26%' }} />
                    <h1 style={{ marginTop: "-5%", fontWeight: 700, fontSize: '36px' }}>Congratulations!</h1>
                    <p className="mt-2">You are now an official Privaposts Creator!</p>
                    <p className="mt-2">Post awesome stuff & earn lots of money!</p>

                    <div className="modal_button_success my-4">
                        <a href={`${window.location.origin}/social-media-influencer-creator-guide/`} type="button" className="btn theme-btn theme-btn-bordered mt-2"> View Creator Guide </a>
                    </div>
                    <div className="modal_button_success my-4">
                        <button id="stopButton" type="button" className="btn theme-btn theme-btn-bordered mt-2" onClick={handleOkay}> Okay!</button></div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PConfettiModal;